import { useDeleteSpeed } from "./api/deleteSpeed";
import { Button } from "reactstrap";


const DeleteSpeed = ({handleCloseModal, speedId}: DeleteSpeedProps)  => {
  
  const deleteSpeedMutation = useDeleteSpeed({ speedId});
  const handleSubmit = async (): Promise<void> => {
    deleteSpeedMutation.mutateAsync({ 
      speedId: speedId
    })

    handleCloseModal();
  }

  return (
    <>
        <label>Είστε σίγουροι οτι θέλετε να διαγράψετε την Ταχύτητα Γραμμής;</label>
        <div>
          <Button style={{ margin: "10px" }} onClick={handleCloseModal}>Ακύρωση</Button>
          <Button style={{ margin: "10px" }} color='danger' onClick={handleSubmit}>Διαγραφή</Button>
        </div>
    </>
  )
}

interface DeleteSpeedProps{
  speedId: number;
  handleCloseModal: () => void;
}

export default DeleteSpeed;